
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.408 8.535V3.032a.518.518 0 00-.056-.227c.02-.056.056-.106.056-.168a.528.528 0 00-.382-.508L8.643.02a.531.531 0 00-.29 0L.971 2.13a.528.528 0 000 1.014l2.781.795v.624c0 .6.333 1.151.849 1.405 2.363 1.161 5.43 1.16 7.795 0 .515-.253.848-.805.848-1.405v-.624l2.11-.603v5.199a1.58 1.58 0 00-1.055 1.485v1.054c0 .292.236.528.527.528h2.11a.527.527 0 00.527-.528V10.02a1.58 1.58 0 00-1.055-1.485z","fill":"#fff"}}),_c('path',{attrs:{"d":"M12.81 6.985a9.937 9.937 0 01-4.363.995 9.944 9.944 0 01-4.363-.996c-.13-.063-.236-.158-.352-.242.113 1.898 1.134 3.509 2.578 4.334 0 0 .74.35.971.415l.001-.001c.375.107.76.182 1.165.182.371 0 .9-.074 1.427-.27.243-.086.71-.325.71-.325 1.443-.825 2.465-2.436 2.578-4.335-.115.085-.223.179-.353.243zM8.448 12.727c-.425 0-.835-.066-1.233-.162l1.233 1.85 1.226-1.848c-.397.095-.804.16-1.226.16zM11.483 11.78l-.03.018-.443.665c0 .025-2.022 3.049-2.035 3.069V18h6.855a.527.527 0 00.527-.527c0-2.88-2.12-5.244-4.874-5.692zm1.183 4.11h-1.055a.527.527 0 110-1.054h1.055a.527.527 0 110 1.055zM5.431 11.792l-.026-.016c-2.753.452-4.868 2.82-4.868 5.697 0 .292.236.527.527.527H7.92v-2.468l-2.489-3.74z","fill":"#fff"}})])
          )
        }
      }
    